import { ResultWithValue } from 'src/models/baseApi.model';
import { GetDownloadUrlSchemaVM, GetUploadUrlResponseDataSchemaVM, GetUploadUrlVM, UploadFileVM } from 'src/models/fileUpload.model';
import { baseApi } from './baseApi.service';

export const fileUploadApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // ############################# GET DOWNLOAD URL #############################
    getDownloadUrl: builder.query<ResultWithValue<GetDownloadUrlSchemaVM>, string>({
      extraOptions: {
        useToken: true,
      },
      query: (fileId) => ({
        url: `1/FileUpload/${fileId}`,
        method: 'GET',
        params: { FileUploadId: fileId },
      }),
    }),
    // ############################# GET UPLOAD URL #############################
    getUploadUrl: builder.mutation<ResultWithValue<GetUploadUrlResponseDataSchemaVM>, GetUploadUrlVM>({
      extraOptions: {
        useToken: true,
      },
      query: ({ fileName, folder }) => ({
        url: '/1/FileUpload',
        method: 'POST',
        body: { fileName: fileName, folder: folder },
      }),
    }),
    // ############################# UPLOAD FILE #############################
    uploadFile: builder.mutation<void, UploadFileVM>({
      extraOptions: {
        useToken: true,
      },
      async queryFn({ fileName, folder, file }, api, options, baseQuery) {
        const { data }: any = await baseQuery({
          url: '/1/FileUpload',
          method: 'POST',
          body: { fileName: fileName, folder: folder },
        })

        const formData = new FormData();
        formData.append('file', file);
        formData.append('Content-Type', data.data.mimeType);

        const response = await fetch(data?.data?.uploadUrl, {
          method: 'PUT',
          body: formData,
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        return { data: data };
      }
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDownloadUrlQuery,
  useLazyGetDownloadUrlQuery,
  useGetUploadUrlMutation,
  useUploadFileMutation
} = fileUploadApi;
